import { Card, CardBody, Col, Row } from "reactstrap";
import { Image } from "../../../AbstractElements";
import { HorizontalScrollbarTitle } from "../../../Constants/Constants";
import { HorizontalScrollSubTitle } from "../../../Data/BonusUi/Scrollable";
import { dynamicImage, dynamicNumber } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import ScrollBar from "react-perfect-scrollbar";

const HorizontalScrollbar = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={HorizontalScrollbarTitle} span={HorizontalScrollSubTitle} />
        <CardBody>
          <ScrollBar className="horizontal-scroll scroll-demo custom-container">
            <div className="horz-scroll-content scroll-content-width">
              <Row>
                {dynamicNumber(6).map((item, index) => (
                  <Col xs="2" key={index}>
                    <div className="horizontal-img">
                      <Image className="img-fluid" src={dynamicImage(`scrollbar/fashion${item}.jpg`)} alt="girl" />
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </ScrollBar>
        </CardBody>
      </Card>
    </Col>
  );
};
export default HorizontalScrollbar;
